import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import styles from './app.module.css'

import { dismissMessage } from '../actions/messagesActions'

function ForbiddenAccess({ history, dismissMessage }) {
  useEffect(() => {
    return () => {
      dismissMessage()
    }
  }, [dismissMessage])

  return (
    <Dialog open={true} PaperProps={{ elevation: 2 }}>
      <DialogTitle variant='h4' color='error'>
        Acesso negado
      </DialogTitle>
      <DialogContent>
        <DialogContentText component='div' className={styles.dialogItem}>
          <Typography variant='h6' style={{ maxWidth: 500 }}>
            Você não tem permissão para acessar este recurso, solicite ao responsável, por favor.
          </Typography>
        </DialogContentText>
        <DialogContentText component='div' className={styles.dialogItem}>
          <Typography variant='subtitle1'>
            Entre em contato através do 0800 644 1500 se o problema persistir.
          </Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className={styles.button} onClick={() => history.push('/')} color='primary'>
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = ({ messages }) => ({ messages })
const reduxEnhanced = connect(mapStateToProps, { dismissMessage })(ForbiddenAccess)

export default withRouter(reduxEnhanced)
